import styled from "styled-components";
import { SearcherItem } from "../../../searcher/styled.js";
import { FlexColumnMixin, FlexMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const SearcherItemOrigin = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherItemOrigin",
    componentId: "sc-6d5a79f4-0"
})`
	${FlexMixin({
    direction: 'column'
})}
	gap: var(--division-gap);

	${({ theme  })=>theme.media.between('md', 'xl')} {
		${({ $mustShowDestination =true  })=>FlexColumnMixin({
        columns: $mustShowDestination ? 2 : 1,
        gap: 'var(--division-gap)'
    })}
	}
`;
export const SearcherItemDestination = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherItemDestination",
    componentId: "sc-6d5a79f4-1"
})`
	${({ theme  })=>theme.media.between('md', 'xl')} {
		${FlexColumnMixin({
    columns: 2,
    gap: 'var(--division-gap)'
})}
	}
`;
export const SearcherItemDate = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherItemDate",
    componentId: "sc-6d5a79f4-2"
})`
	${({ theme  })=>theme.media.between('md', 'lg')} {
		--base-width: calc(100% - 150px - var(--division-gap));
	}

	${({ theme  })=>theme.media.between('lg', 'xl')} {
		--base-width: calc(100% - 150px - var(--division-gap) - 170px - var(--division-gap));
	}

	${({ theme  })=>theme.media.between('md', 'xl')} {
		--flex-column-width: calc((var(--base-width) - var(--division-gap)) / 2);
	}
`;
export const SearcherItemAge = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherItemAge",
    componentId: "sc-6d5a79f4-3"
})`
	${({ theme  })=>theme.media.between('md', 'lg')} {
		--flex-column-width: 150px;
	}

	${({ theme  })=>theme.media.between('lg', 'xl')} {
		--flex-column-width: 170px;
	}
`;

//# sourceMappingURL=styled.js.map